import { render, staticRenderFns } from "./InProcessClassification.vue?vue&type=template&id=1fb251b9&"
import script from "./InProcessClassification.vue?vue&type=script&lang=js&"
export * from "./InProcessClassification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports